module.exports = __webpack_public_path__ + "static/media/product-2.ad7ef891.png";